import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BalanceHistoryComponent } from '@pg-app/client/client-dashboard/components/my-balance/balance-history/balance-history.component';

@Component({
  selector: 'np-my-balance',
  templateUrl: './my-balance.component.html',
  styleUrls: ['./my-balance.component.scss']
})
export class MyBalanceComponent implements OnInit, OnChanges {
  @Input() 
  public allBalances: any;

  constructor(
    private dialog: MatDialog
  ) {
  }

  balances = [];
  isLoading = true;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('allBalances' in changes) {
      this.balances = changes.allBalances.currentValue;
      if (!changes.allBalances.firstChange)  { 
        this.isLoading = false;
      }
    }
  }

  showBalanceHistory(event) {
    this.dialog.open(BalanceHistoryComponent, {
      data: event
    });
  }
}
